module.exports = __webpack_public_path__ + "img/sad_emoji.368a46d.png";